export default __webpack_public_path__ + "static/media/placeholder.494ff3e4.svg";